/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopifyStoreIdDto } from '../../models/shopify-store-id-dto';

export interface ShopifyAppControllerGetStoreId$Params {

/**
 * Shop domain(s) to resolve. Repeat the param for several domains; the first matching store wins.
 */
  shop: Array<string>;

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
}

export function shopifyAppControllerGetStoreId(http: HttpClient, rootUrl: string, params: ShopifyAppControllerGetStoreId$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopifyStoreIdDto>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerGetStoreId.PATH, 'get');
  if (params) {
    rb.query('shop', params.shop, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopifyStoreIdDto>;
    })
  );
}

shopifyAppControllerGetStoreId.PATH = '/api/v1/shopify-app/store-id';
